import { Product } from "@/types/product";
import ProductCard from "./ProductCard";
import { Button } from "./ui/button";
import { useState } from "react";

interface ProductGridProps {
  products: Product[];
}

export const ProductGrid = ({ products }: ProductGridProps) => {
  const [displayCount, setDisplayCount] = useState(4);
  const loadMoreAmount = 8;

  const displayedProducts = products.slice(0, displayCount);

  const handleShowMore = () => {
    setDisplayCount(prev => Math.min(prev + loadMoreAmount, products.length));
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {displayedProducts.map((product) => (
          <ProductCard key={product.objectID} product={product} />
        ))}
      </div>
      
      {displayCount < products.length && (
        <div className="flex justify-center mt-6">
          <Button 
            onClick={handleShowMore}
            variant="outline"
          >
            Show More
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;